<template>
    <el-dialog
            :before-close="onCancel"
            :close-on-click-modal="false"
            title="查看详情"
            :visible.sync="dialogVisible"
            @open="open"
            width="60%"
    >
        <div class="content-area"
             v-loading="loading"
             element-loading-text="加载中...">
            <div class="content-info marginB20">
                <div class="content-title">考生信息：</div>
                <div class="content-info-box">
                    <div class="info-area">
                        <div class="info-area-item"
                             v-for="(item, index) in sortStuInfo"
                             :key="index">
                            {{item}}：{{stuInfo[item]}}
                        </div>
                    </div>
                    <div class="pic-area">
                        <el-image v-if="stuInfo['导入照片']" :src="stuInfo['导入照片']">
                            <div slot="placeholder" class="image-slot">
                                <i class="el-icon-loading img-loading"></i>
                            </div>
                        </el-image>
                    </div>
                </div>
            </div>
            <div class="content-table">
                <div class="content-title">检录情况：</div>
                <el-table :data="tableData">
                    <el-table-column prop="环节名称" label="环节名称" align="center"></el-table-column>
                    <el-table-column prop="检录状态" label="检录状态" align="center">
                        <template slot-scope="scope">
                            <span class="ytg_color" v-if="scope.row['检录状态']==='通过'">通过</span>
                            <span class="wtg_color" v-else-if="scope.row['检录状态']==='未通过'">未通过</span>
                            <span class="wsb_color" v-else-if="scope.row['检录状态']==='未识别'">未识别</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="检录类型" label="检录类型" align="center"></el-table-column>
                    <el-table-column prop="未通过提示" label="未通过提示" align="center"></el-table-column>
                    <el-table-column prop="公安认证" label="公安认证" align="center">
                        <template slot-scope="scope">
                            <span class="ytg_color" v-if="scope.row['公安认证']==='通过'">通过</span>
                            <span class="wtg_color" v-else-if="scope.row['公安认证']==='未通过'">未通过</span>
                            <span class="wsb_color" v-else-if="scope.row['公安认证']==='未识别'">未识别</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="证件照片" label="证件照片" align="center">
                        <template slot-scope="scope">
                            <el-image class="table-image" v-if="scope.row['证件照片']" :src="scope.row['证件照片']"
                                      :preview-src-list="[scope.row['证件照片']]">
                                <div slot="placeholder" class="image-slot">
                                    <i class="el-icon-loading img-loading"></i>
                                </div>
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="实时照片" label="实时照片" align="center">
                        <template slot-scope="scope">
                            <el-image class="table-image" v-if="scope.row['实时照片']" :src="scope.row['实时照片']"
                                      :preview-src-list="[scope.row['实时照片']]">
                                <div slot="placeholder" class="image-slot">
                                    <i class="el-icon-loading img-loading"></i>
                                </div>
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="登记照片" label="登记照片" align="center">
                        <template slot-scope="scope">
                            <el-image class="table-image" v-if="scope.row['登记照片']" :src="scope.row['登记照片']"
                                      :preview-src-list="[scope.row['登记照片']]">
                                <div slot="placeholder" class="image-slot">
                                    <i class="el-icon-loading img-loading"></i>
                                </div>
                            </el-image>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    import {DetailInfo} from "../request/record";
    import {mapGetters} from "vuex";

    export default {
        name: "ViewInfo",
        props: {
            idFu: [String, Number],
            dialogVisibleFu: Boolean,
        },
        data() {
            return {
                loading: false,
                id: this.idFu,
                dialogVisible: this.dialogVisibleFu,
                sortStuInfo: [],// 考生信息对象key值数组
                tableData: [],
                stuInfo: {}
            };
        },
        methods: {
            open() {
                this.getList();
            },
            getList() {
                if (this.loading) {
                    return false;
                }
                this.loading = true;
                DetailInfo({
                    eventCount: this.getSession,
                    id: this.id,
                })
                    .then((res) => {
                        // console.log(res)
                        if (res.code != 200) {
                            this.loading = false;
                            return this.$message.error(res.message);
                        }
                        this.sortStuInfo = res.data.sortStuInfo;
                        this.tableData = res.data.checkInfo;
                        this.stuInfo = res.data.stuInfo;
                        this.loading = false;
                    })
                    .catch((err) => {
                        // console.log(err);
                        this.loading = false;
                    });
            },
            onCancel() {
                this.sortStuInfo = [];
                this.tableData = [];
                this.stuInfo = {};
                this.dialogVisible = false;
                this.$emit("closeDialog", this.dialogVisible);
            },
        },
        computed: {
            ...mapGetters([
                'getSession',
            ])
        },
        watch: {
            idFu() {
                this.id = this.idFu;
            },
            dialogVisibleFu() {
                this.dialogVisible = this.dialogVisibleFu;
            },
        },
    };
</script>

<style scoped lang="scss">
    .marginB20 {
        margin-bottom: 20px;
    }

    .content-title {
        font-size: 16px;
        font-weight: bold;
        line-height: 24px;
        margin-bottom: 10px;
    }

    .content-info {
        border: 1px solid #EBEBEB;
        border-radius: 4px;
        padding: 20px;

        .content-info-box {
            font-size: 14px;
            display: flex;
            flex-flow: row;
            justify-content: space-between;
            align-items: flex-start;

            .info-area {
                flex: 1;
                display: flex;
                flex-flow: row;
                flex-wrap: wrap;

                .info-area-item {
                    width: calc(50%);
                    line-height: 18px;
                    margin: 5px 0;
                }
            }

            .pic-area {
                width: 120px;
                height: 170px;
                border: 1px solid #EBEBEB;
                border-radius: 4px;
                display: flex;
                flex-flow: row;
                align-items: center;
                justify-content: center;

                > .el-image {
                    max-width: 100%;
                    max-height: 100%;
                }
            }
        }
    }

    .content-table {
        padding: 20px;
    }
</style>
